import styled from 'styled-components';
import FreeParkingIconSvg from '../../assets/hotels/amenities/FreeParking.svg';

const FreeParkingIcon = styled(FreeParkingIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default FreeParkingIcon;
